import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { DatePipe } from "@angular/common";

import jsPDF from 'jspdf';
//import 'jspdf-autotable';

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import htmlToPdfmake from 'html-to-pdfmake';
import { map } from 'rxjs/operators';
import { firstValueFrom, Observable } from 'rxjs'
//(pdfMake as any).vfs = (pdfFonts as any).pdfMake.vfs;
const vfs = (pdfFonts as any)?.pdfMake?.vfs;
if (vfs) {
  (pdfMake as any).vfs = vfs;
}

declare const $: any;

type AOA = any[][];

@Injectable({
  providedIn: 'root'
})

//59 Shivam 

export class ApidataService {
  pipe = new DatePipe("en-US");


  // base_url: String = "http://localhost:4200/";
  // api_baseurl: String = "http://localhost:8443/";
  // server_uploads = "http://localhost:8443/";

  //  api_baseurl: String = "https://hrmking2.hrmking.com:8443/";
  //  base_url:String = "https://hrmking2.hrmking.com/";
  //  server_uploads = "https://hrmking2.hrmking.com:8443/";

  //  api_baseurl: String = "https://hrnode.hrmking.com/";
  //  server_uploads = "https://hrnode.hrmking.com/";
  //  base_url:String = "https://hrmking.com/";

  base_url: String = "https://hrmking.com/";
  api_baseurl: String = "https://hrmking.com:8443/";
  server_uploads = "https://hrmking.com:8443/";

  constructor(private http: HttpClient) { }

  loadSalaryRule(adminId) {
    return this.http.get(this.api_baseurl + "admin/salary/getrules/" + adminId)
  }
  SalaryHeadMaster(adminId) {
    return this.http.get(this.api_baseurl + "admin/salary/salaryheadmast/" + adminId)
  }

  GetDepartment(adminId) {
    return this.http.get(this.api_baseurl + "admin/department/getAdminData/" + adminId)
  }
  GetDepartmentPromis(adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/department/getAdminData/" + adminId).toPromise();
  }

  GetCompanyInfo(adminId) {
    return this.http.get(this.api_baseurl + "admin/companyDetails/getCompanyDetails/" + adminId);
  }

  GetDefaultCompany(adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/company/getdefault/" + adminId).toPromise()
  }

  checkEmployee(adminId: string, field: string, value: string, companyId: string = ''): Promise<any> {
    return this.http.post(this.api_baseurl + 'admin/employee/check-exist', {
      adminId: adminId,
      companyId: companyId,
      field,
      value
    }).toPromise();
  }

  checkFinYear(adminId: string, finId: any, moduleName: string): Promise<any> {
    let obj = { finId: finId, module: moduleName }
    return this.http.post(this.api_baseurl + 'admin/financialyear/check-exist/' + adminId, obj).toPromise()
  }

  isJsonObject(value) {
    return (
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value)
    );
  }


  ExportTOExcel(table, excelfilaname) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, excelfilaname + '.xlsx');
  }

  ImportExcel(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader: FileReader = new FileReader();

      reader.onload = (event: any) => {
        const binaryData = event.target.result;
        const workbook = XLSX.read(binaryData, { type: 'binary' });

        // Assuming the data is in the first sheet
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const data = XLSX.utils.sheet_to_json(worksheet); // JSON format

        resolve(data); // Return the data once loaded
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsBinaryString(file); // Start reading the file

    });
    // let data:AOA = [[1, 2], [3, 4]];
    // /* wire up file reader */

    // const target: DataTransfer = <DataTransfer>(evt.target);

    // if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    // const reader: FileReader = new FileReader();

    // reader.readAsBinaryString(target.files[0]);
    // reader.onload = (e:any)=>{

    //    /* read workbook */

    //    const bstr: string = e.target.result;
    //    const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

    //     /* grab first sheet */
    //   const wsname: string = wb.SheetNames[0];
    //   const ws: XLSX.WorkSheet = wb.Sheets[wsname];
    //    /* save data */
    //    data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
    //    return data;
    // }
  }

  GetCompanies(adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/company/list/" + adminId).toPromise();
  }
  getCompanies(adminId): Promise<any> {
    return this.GetCompanies(adminId);
  }
  GetCompanyInfoPromise(id, adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/company/info/" + id + "/" + adminId).toPromise();
  }

  CompanyBranch(adminId, companyId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/branch/companybranch/" + companyId + "/" + adminId).toPromise();
  }
  getCompanyBranch(adminId, companyId): Promise<any> {
    return this.CompanyBranch(adminId, companyId);
  }

  LoadSalaryTemplate(adminId) {
    return this.http.get(this.api_baseurl + "admin/salarytemplate/list/" + adminId)
  }
  GetSalaryStructure(adminId, tempId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/salarytemplate/gettemplate/" + adminId + "/" + tempId).toPromise();
  }

  Department(adminId) {
    return this.http.get(this.api_baseurl + "admin/department/getAdminData/" + adminId)
  }

  Branch(adminId) {
    return this.http.get(this.api_baseurl + "admin/branch/getAdminData/" + adminId)
  }
  GetEmployees(adminId) {
    return this.http.get(this.api_baseurl + "admin/allemployees/getActiveInactiveallEmployee/" + adminId)
  }

  GetEmployeesPrmise(adminId): Promise<any> {
    //return this.http.get(this.api_baseurl+"admin/allemployees/getActiveInactiveallEmployee/"+ adminId).toPromise();
    return this.http.get(this.api_baseurl + "admin/allemployees/getActiveAllEmployee/" + adminId).toPromise();
  }
  GetEmployeePromiss(adminId): Promise<any> {
    return this.GetEmployeesPrmise(adminId);
  }
  getEmployeesPromise(adminId): Promise<any> {
    return this.GetEmployeesPrmise(adminId);
  }

  GetRoles(adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/roles/list/" + adminId).toPromise();
  }

  Designation(adminId) {
    return this.http.get(this.api_baseurl + "admin/designation/getData/" + adminId);
  }

  GetDesignation(adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/designation/getData/" + adminId).toPromise();
  }

  SalaryTemplate(adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/salarytemplate/list/" + adminId).toPromise();
  }

  GetHelpData(adminId, category): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/help/gethelp/" + adminId + "/" + category).toPromise();
  }

  GetCategory(adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/category/getCategory/" + adminId).toPromise()
  }

  getFinYear(adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/financialYear/getData/" + adminId).toPromise();
  }

  getCompanyFinYear(adminId, companyId): Observable<any> {
    return this.http.get<any>(this.api_baseurl + "admin/financialYear/getData/" + adminId + "/" + companyId)
  }

  async getActiveFinYear(adminId) {
    let finyear: any[] = await this.getFinYear(adminId);
    let activeyear = finyear.find(f => f.status == 1);
    return activeyear;
  }

  async getCompanyActiveFinYear(adminId, companyId) {
    let finyear: any[] = await firstValueFrom(this.getCompanyFinYear(adminId, companyId));
    console.log("Fin year lalala ", finyear)
    let activeyear = finyear.find(f => f.status == 1);
    return activeyear;
  }

  getLeaveType(adminId, finId, companyId = ''): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/leaveType/getLeaveType/" + adminId + "/" + finId + "?companyId=" + companyId).toPromise();
  }

  getEmpLeaveType(adminId, empId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/leaveType/getEmpLeaveType/" + empId + "/" + adminId).toPromise();
  }

  getCompanyLeaveType(adminId, companyId, finId): Observable<any> {
    return this.http.get(this.api_baseurl + "admin/leaveType/company_leave_type/" + adminId + "/" + companyId + "/" + finId);
  }

  getLeaveInfo(adminId, leaveid): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/leavetype/leavetype-info/" + adminId + "/" + leaveid).toPromise()
  }

  getHolidayInfo(adminId, holidayId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/holidays/holidayinfo/" + adminId + "/" + holidayId).toPromise();
  }
  getHolidays(adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/holidays/getHolidays" + "/" + adminId).toPromise()
  }

  getCompanyHolidays(adminId, companyId, year, holidayOption): Observable<any> {
    console.log("Year ", year)
    const post = { optionHoliday: holidayOption, year: year }
    return this.http.post(this.api_baseurl + "admin/holidays/companyholidays/" + adminId + "/" + companyId, post)
  }

  getOptionalHolidays(adminId, year): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/option-holidays/list/" + adminId + "/" + year).toPromise()
  }
  getCompanyOptionHoliday(adminId, companyId, year): Observable<any> {
    return this.http.get(this.api_baseurl + "admin/option-holidays/list/" + adminId + "/" + companyId + "/" + year)
  }

  ScheduleByType(adminId, shifttype): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/shift&schedule/schedule/schedulebytype/" + adminId + "/" + shifttype).toPromise();
  }

  getEmpShcedule(adminId, empId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/shift&schedule/scheduleemployee/emp_schedule/" + empId + "/" + adminId).toPromise();
  }

  getAllSchedule(adminId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/shift&schedule/schedule/getSchedule/" + adminId).toPromise();
  }

  getEmpPaySlip(adminId, empId): Promise<any> {
    return this.http.get(this.api_baseurl + "admin/salary/employee-slip/" + empId + "/" + adminId).toPromise();
  }

  getEmpCof(adminId, empId): Promise<any> {
    return this.http.post(this.api_baseurl + "admin/attendance/cof", { adminId: adminId, empId: empId }).toPromise();
  }

  currentMonth() {
    return (new Date().getMonth() + 1);
  }
  currentYear() {
    return (new Date().getFullYear().toString());
  }
  currentDate() {
    let current = new Date;
    return this.pipe.transform(current, 'YYYY-MM-dd');
  }


  firstDateofMonth(strdate) {
    let dd = new Date(strdate);
    let firstdate = new Date(dd.getFullYear(), dd.getMonth(), 1);
    return this.pipe.transform(firstdate, 'YYYY-MM-dd');
  }

  lastDateofMonth(strdate) {
    let dd = new Date(strdate);
    let lastdate = new Date(dd.getFullYear(), dd.getMonth() + 1, 0);
    return this.pipe.transform(lastdate, 'yyyy-MM-dd');
  }

  formateDate(strdate) {
    return this.pipe.transform(strdate, 'YYYY-MM-dd');
  }

  subtractDayInDate(strdate, days) {
    var d = new Date(strdate);
    d.setDate(d.getDate() - days);
    return this.pipe.transform(d, 'YYYY-MM-dd');
  }

  addDayInDate(strdate, days) {
    var d = new Date(strdate);
    d.setDate(d.getDate() + days);
    return this.pipe.transform(d, 'YYYY-MM-dd');
  }



  getTimeDifference(punchTime: string, shiftTime: string, entryType: 'LATE' | 'EARLY'): string {
    if (!punchTime) {
      return '00:00';
    }
    if (punchTime == '00:00') {
      return '00:00';
    }
    const [punchHour, punchMin] = punchTime.split(':').map(Number);
    const [shiftHour, shiftMin] = shiftTime.split(':').map(Number);

    const punch = new Date();
    punch.setHours(punchHour, punchMin, 0, 0);

    const shift = new Date();
    shift.setHours(shiftHour, shiftMin, 0, 0);

    let diffMs: number;

    if (entryType === 'LATE' && punch > shift) {
      diffMs = punch.getTime() - shift.getTime();
    } else if (entryType === 'EARLY' && punch < shift) {
      diffMs = shift.getTime() - punch.getTime();
    } else {
      return '00:00'; // No valid difference (either not late or not early)
    }

    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    //console.log("Time ", `${this.padZero(hours)}:${this.padZero(minutes)}`)
    return `${this.padZero(hours)}:${this.padZero(minutes)}`;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  getLastMonthDate(lastmonth) {
    const today = new Date();
    today.setMonth(today.getMonth() - lastmonth);
    const pad = (n: number) => n.toString().padStart(2, '0');
    const lastmonthdate = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    return lastmonthdate;
  }

  localDateFormat(strdate) {
    return this.pipe.transform(strdate, 'dd-MM-YYYY');
  }

  getFirstAndLastDateOfMonth(month: number, year: number = new Date().getFullYear()): { firstDate: string, lastDate: string } {
    const pad = (n: number) => n.toString().padStart(2, '0');

    const firstDateObj = new Date(year, month - 1, 1);
    const lastDateObj = new Date(year, month, 0);

    const firstDate = `${firstDateObj.getFullYear()}-${pad(firstDateObj.getMonth() + 1)}-${pad(firstDateObj.getDate())}`;
    const lastDate = `${lastDateObj.getFullYear()}-${pad(lastDateObj.getMonth() + 1)}-${pad(lastDateObj.getDate())}`;

    return { firstDate, lastDate };
  }

  monthlist() {
    const months = [
      { name: 'January', value: "1" },
      { name: 'February', value: "2" },
      { name: 'March', value: "3" },
      { name: 'April', value: "4" },
      { name: 'May', value: "5" },
      { name: 'June', value: "6" },
      { name: 'July', value: "7" },
      { name: 'August', value: "8" },
      { name: 'September', value: "9" },
      { name: 'October', value: "10" },
      { name: 'November', value: "11" },
      { name: 'December', value: "12" }
    ]
    return months;
  }

  monthName(monthnum: any) {

    let monthname = ""
    switch (monthnum) {
      case "1":
        monthname = "January"
        break;
      case "2":
        monthname = "February";
        break;
      case "3":
        monthname = "March";
        break;
      case "4":
        monthname = "April";
        break;
      case "5":
        monthname = "May";
        break;
      case "6":
        monthname = "June";
        break;
      case "7":
        monthname = "July";
        break;
      case "8":
        monthname = "August";
        break;
      case "9":
        monthname = "September";
        break;
      case "10":
        monthname = "October";
        break
      case "11":
        monthname = "November";
        break;
      case "12":
        monthname = "December"
        break;
      default:
        monthname = "";
        break;
    }

    return monthname;
  }

  GetDayName(strdate: any) {
    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let d = new Date(strdate);
    let dayName = days[d.getDay()];
    return dayName;
  }

  calculateDiff(strdate1, strdate2) {
    var date1: any = new Date(strdate1);
    var date2: any = new Date(strdate2);
    var diffDays: any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
    if (strdate1 != strdate2) {
      diffDays = diffDays + 1;
    } else {
      diffDays = 1;
    }
    return diffDays;
  }

  SplitString(value, seprator) {
    return value.includes(seprator)
      ? `${value.split(seprator)[0]} (${value.split(seprator)[1]})`
      : value;
  }

  modalpopup(modalname: string, status: string) {
    if (status == 'open') {
      $(modalname).modal('show');
    }

    if (status == 'close') {
      $(modalname).modal('hide');
    }
  }

  getMenuItems() {
    return this.http.get<any>("../../assets/sidebarmenu/settingsmenu.json").pipe(map((data: any) => {
      const filteredData: any = {};

      // Loop through all keys in JSON (salary_structure, shift_sheduling...)
      for (let key of Object.keys(data)) {
        if (Array.isArray(data[key])) {
          filteredData[key] = data[key].filter(item => item.status === 1);
        }
      }

      return filteredData;
    })
    );
  }



  exportToPdf(filename, title, displayedColumns: any = [], tablerows: any = []) {
    const doc = new jsPDF();

    //const columns = displayedColumns.map(col => col[0]); // Table headers
    const columns = displayedColumns;
    //const rows = this.dataSource.map((item, index) => [index+1, item.patient_name, item.hospital_name, item.claim_amount,item.approve_amount]); // Table rows
    const rows = tablerows; // Table rows

    // Add a title
    doc.text(title, 20, 10);

    // Add table using autoTable
    (doc as any).autoTable({
      head: [columns],
      body: rows,
    });

    // Save the PDF
    doc.save(filename + '.pdf');
  }

  PDFView(content: any, header: any, filename: string) {
    let cleanedContent = (content || '')
      .replace(/(<p>\s*(<br\s*\/?>|&nbsp;|\s)*<\/p>\s*){2,}/gi, '<p><br></p>')
      .replace(/(<br\s*\/?>\s*){3,}/gi, '<br><br>');

    let pdfContent: any = [];
    try {
      pdfContent = htmlToPdfmake(cleanedContent, {
        defaultStyles: {
          p: { margin: [0, 2, 0, 6], fontSize: 10, lineHeight: 1.4, color: '#1e293b' },
          h1: { fontSize: 15, bold: true, color: '#0f2942', margin: [0, 8, 0, 4] },
          h2: { fontSize: 13, bold: true, color: '#0f2942', margin: [0, 6, 0, 3] },
          h3: { fontSize: 11, bold: true, color: '#1e3a8a', margin: [0, 5, 0, 2] },
          h4: { fontSize: 10, bold: true, color: '#1e3a8a', margin: [0, 4, 0, 2] },
          b: { bold: true, color: '#0f172a' },
          strong: { bold: true, color: '#0f172a' },
          ul: { margin: [0, 2, 0, 6] },
          ol: { margin: [0, 2, 0, 6] },
          li: { margin: [0, 1, 0, 2], fontSize: 10, lineHeight: 1.35 },
          table: { margin: [0, 4, 0, 8] },
          th: { bold: true, fillColor: '#f1f5f9', color: '#0f172a', fontSize: 9.5 },
          td: { fontSize: 9.5, color: '#334155' }
        }
      });
    } catch (e) {
      console.warn('PDF content parse error:', e);
      pdfContent = [{ text: content || '' }];
    }

    const docContent: any[] = [];

    if (header) {
      try {
        const headerdata = htmlToPdfmake(header);
        if (headerdata && headerdata.length > 0) {
          // Check if header contains a table
          const tableElement = headerdata.find((item: any) => item && item.table && item.table.body) || (headerdata[0]?.table?.body ? headerdata[0] : null);
          if (tableElement && tableElement.table && tableElement.table.body) {
            docContent.push({
              table: {
                widths: ['25%', '40%', '35%'],
                body: tableElement.table.body,
              },
              layout: 'noBorders',
            });
          } else {
            // Header is non-table (paragraphs, text, divs)
            if (Array.isArray(headerdata)) {
              docContent.push(...headerdata);
            } else {
              docContent.push(headerdata);
            }
          }
          // Subtle header separator line
          docContent.push({
            canvas: [
              { type: 'line', x1: 0, y1: 0, x2: 511, y2: 0, lineWidth: 2, lineColor: '#1e40af' },
              { type: 'line', x1: 0, y1: 3, x2: 511, y2: 3, lineWidth: 0.5, lineColor: '#cbd5e1' }
            ],
            margin: [0, 6, 0, 10]
          });
        }
      } catch (err) {
        console.warn('PDF header parse error:', err);
      }
    }

    if (Array.isArray(pdfContent)) {
      docContent.push(...pdfContent);
    } else if (pdfContent) {
      docContent.push(pdfContent);
    }

    const documentDefinition: any = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      pageMargins: [42, 35, 42, 45],
      footer: (currentPage: number, pageCount: number) => {
        return {
          stack: [
            {
              canvas: [{ type: 'line', x1: 0, y1: 0, x2: 511, y2: 0, lineWidth: 0.5, lineColor: '#e2e8f0' }],
              margin: [0, 0, 0, 5]
            },
            {
              columns: [
                {
                  text: 'Private & Confidential',
                  fontSize: 7.5,
                  color: '#94a3b8'
                },
                {
                  text: pageCount > 1 ? `Page ${currentPage} of ${pageCount}` : '',
                  fontSize: 7.5,
                  color: '#64748b',
                  alignment: 'right'
                }
              ]
            }
          ],
          margin: [42, 8, 42, 0]
        };
      },
      content: docContent,
      defaultStyle: {
        font: 'Roboto',
        fontSize: 10,
        lineHeight: 1.4,
        color: '#1e293b'
      }
    };
    pdfMake.createPdf(documentDefinition).download((filename || 'document') + '.pdf');
  }

  convertImgToBase64URL(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // Allows cross-origin images (if permitted)
      img.src = url;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png'); // Convert to Base64
          resolve(dataURL);
        } else {
          reject("Canvas not supported");
        }
      };

      img.onerror = () => {
        console.error("Image loading error, replacing with a placeholder");
        resolve(''); // Resolve with empty string if image fails
      };
    });
  }



}
